@if (svg(); as chart) {
    <div class="chart-svg" role="img" [attr.aria-label]="label() || ('common.cardType.chart' | translate)" [innerHTML]="chart"></div>
} @else {
    <div class="chart-empty">
        <ra-icon icon="chart" varColor="currentColor" [size]="22" />
        <span>{{ (isEmpty() ? 'document.edit.chart.card.empty' : 'document.edit.chart.preview.loading') | translate }}</span>
    </div>
}
